const menuDrawerContainer = document.querySelector(".menu-drawer-container");
const shopSubmenu = menuDrawerContainer.querySelector("li details");
const submenu = shopSubmenu.querySelector(".menu-drawer__submenu");
menuDrawerContainer.addEventListener("click", function (event) {
  console.log(event.currentTarget);
  if (event.currentTarget.hasAttribute("open")) {
    // The drawer will be Closed
  } else {
    // The drawer will be opened
    shopSubmenu.setAttribute("open", "");
    submenu.style.visibility = "visible";
  }
});
